export default __webpack_public_path__ + "static/media/banner-reaction-11.eaa6a88a.png";